import { render, staticRenderFns } from "./GiselleCarnaby.vue?vue&type=template&id=3b7f80fe"
import script from "./GiselleCarnaby.vue?vue&type=script&lang=ts"
export * from "./GiselleCarnaby.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports